<div class="loading-spinner-wrapper" role="status">
    <div class="loading-spinner" role="img" aria-label="loading"></div>
</div>
